var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "#888281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.352 11.608C13.888 10.904 15.584 10.328 17.28 10.328C19.136 10.328 20.96 11.128 20.96 13.24C20.96 14.904 19.776 15.864 18.592 17.176C17.44 18.488 16.256 20.152 16.256 23.192H20.192C19.808 19 25.632 17.208 25.632 12.728C25.632 8.632 22.016 7 18.336 7C16.192 7 14.048 7.448 12 8.056L12.352 11.608ZM16 29.72H20.48V25.24H16V29.72Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.e521fb72eb4b1d97511d9bf4e3a28b42.svg";
export { ForwardRef as ReactComponent };